var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header", { ref: "header", on: { close_modal: _vm.closeModal } }),
      _vm._v(" "),
      _c("loading", {
        attrs: { active: _vm.isLoading, "enforce-focus": false },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { margin: "10px 20px" } },
        [
          _c(
            "div",
            {
              staticClass: "form-inline",
              staticStyle: { "margin-bottom": "5px" },
            },
            [
              _c(
                "b-form-select",
                {
                  staticStyle: { width: "100px" },
                  on: { change: _vm.onDateChange },
                  model: {
                    value: _vm.on_type,
                    callback: function ($$v) {
                      _vm.on_type = $$v
                    },
                    expression: "on_type",
                  },
                },
                _vm._l(_vm.sel_on_type, function (option) {
                  return _c(
                    "option",
                    { key: option.id, domProps: { value: option.value } },
                    [
                      _vm._v(
                        "\n          " + _vm._s(option.text) + "\n        "
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("v-date-picker", {
                staticClass: "date_picker",
                on: { input: _vm.onDateChange },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ inputValue, inputEvents }) {
                      return [
                        _c(
                          "b-input",
                          _vm._g(
                            { attrs: { value: inputValue, readonly: "" } },
                            inputEvents
                          )
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.date1,
                  callback: function ($$v) {
                    _vm.date1 = $$v
                  },
                  expression: "date1",
                },
              }),
              _vm._v("\n       - \n      "),
              _c("v-date-picker", {
                staticClass: "date_picker",
                attrs: { "is-required": "" },
                on: { input: _vm.onDateChange },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ inputValue, inputEvents }) {
                      return [
                        _c(
                          "b-input",
                          _vm._g(
                            { attrs: { value: inputValue, readonly: "" } },
                            inputEvents
                          )
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.date2,
                  callback: function ($$v) {
                    _vm.date2 = $$v
                  },
                  expression: "date2",
                },
              }),
              _vm._v("\n        \n      "),
              _vm.mitumori_sel_load
                ? _c(
                    "b-button",
                    {
                      staticStyle: { width: "140px !important" },
                      attrs: { variant: "info", disabled: "" },
                    },
                    [
                      _c("b-spinner", { attrs: { small: "" } }),
                      _vm._v("\n        Loading...\n      "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v("\n          \n      受注："),
              _c("font", { attrs: { color: "#ff0000" } }, [
                _vm._v(_vm._s(_vm.jyutyu_x_cnt)),
              ]),
              _vm._v("\n        \n      納品："),
              _c("font", { attrs: { color: "#ff0000" } }, [
                _vm._v(_vm._s(_vm.nouhin_x_cnt)),
              ]),
              _vm._v("（"),
              _c("font", { attrs: { color: "#ff7f50" } }, [
                _vm._v(_vm._s(_vm.nouhin_enb_cnt)),
              ]),
              _vm._v(")\n        \n      請求："),
              _c("font", { attrs: { color: "#ff0000" } }, [
                _vm._v(_vm._s(_vm.seikyu_x_cnt)),
              ]),
              _vm._v("\n        \n      入金："),
              _c("font", { attrs: { color: "#ff0000" } }, [
                _vm._v(_vm._s(_vm.nyukin_x_cnt)),
              ]),
              _vm._v("\n        \n      "),
              _c(
                "div",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-button",
                    {
                      staticStyle: {
                        width: "130px !important",
                        padding: "8px 0px",
                      },
                      attrs: {
                        variant: "info",
                        disabled: _vm.pms_master_item < 2,
                      },
                      on: {
                        click: _vm.showCsvImport,
                        close_modal: _vm.closeModal,
                      },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "file-earmark-arrow-down" },
                      }),
                      _vm._v(" インポート\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("MitumoriCsvImport", {
                    ref: "csv_import",
                    attrs: { modal_id: "mitumori-csv_import" },
                    on: { close_modal: _vm.getMitumoriList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              style:
                "width: " +
                _vm.maxWidth +
                "; overflow:auto; position: relative;",
            },
            [
              _c(
                "div",
                { staticStyle: { "min-width": "1250" } },
                [
                  _c("b-table-filter-pager", {
                    attrs: {
                      busy: _vm.mitumori_load,
                      maxHeight: _vm.maxHeight,
                      filter_list: _vm.filter_list,
                      filter_val: _vm.filter_val,
                      filter_val_ex: _vm.filter_val_ex,
                      data_count: _vm.data_count,
                      tooltip_plus: { title: "見積書の新規追加" },
                      currentPage: _vm.current_page,
                      data_list_field: _vm.data_list_field,
                      data_list: _vm.data_list,
                      nav_flg: true,
                      filter_enable: true,
                    },
                    on: {
                      on_sort: _vm.onSort,
                      on_page_change: _vm.onPageChange,
                      on_edit: _vm.onDetail,
                      on_filter_ex: _vm.onFilterEx,
                      jyutyu_show: _vm.jyutyuShow,
                      nouhin_show: _vm.nouhinShow,
                      henpin_show: _vm.henpinShow,
                      seikyu_show: _vm.seikyuShow,
                      nyukin_show: _vm.nyukinShow,
                      on_add: _vm.modalShow,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        position: "absolute",
                        right: "10px",
                        bottom: "10px",
                        display: "flex",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("label", { staticClass: "mr-2 mb-0" }, [
                        _vm._v("合計"),
                      ]),
                      _vm._v(" "),
                      _c("b-input", {
                        staticStyle: { width: "140px", "text-align": "right" },
                        attrs: { type: "text", disabled: "" },
                        model: {
                          value: _vm.price_total,
                          callback: function ($$v) {
                            _vm.price_total = $$v
                          },
                          expression: "price_total",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-mitumori",
                title: "見積 > 追加",
                "header-bg-variant": "dark",
                "header-text-variant": "light",
                "body-bg-variant": "light",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c("div", { staticClass: "modal_div" }, [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", {}, [_vm._v("見積日")]),
                    _vm._v(" "),
                    _c("v-date-picker", {
                      staticClass: "date_picker",
                      attrs: { "is-required": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c(
                                "b-input",
                                _vm._g(
                                  {
                                    attrs: {
                                      value: inputValue,
                                      readonly: true,
                                    },
                                  },
                                  inputEvents
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.mitumori.mitumori_on,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori, "mitumori_on", $$v)
                        },
                        expression: "mitumori.mitumori_on",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("品題")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "350px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.mitumori.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori, "title", $$v)
                        },
                        expression: "mitumori.title",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("品類")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "200px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.mitumori.teiki_type1,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori, "teiki_type1", $$v)
                        },
                        expression: "mitumori.teiki_type1",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("品目")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "200px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.mitumori.teiki_type2,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori, "teiki_type2", $$v)
                        },
                        expression: "mitumori.teiki_type2",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("SelectClientCompany", {
                      ref: "select_client_company_ref",
                      on: { on_select: _vm.onClientCompanySelect },
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("顧客")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: {
                        width: "200px",
                        "background-color": "white",
                      },
                      attrs: { type: "text", readonly: "" },
                      on: { click: _vm.selectClientCompanyModalShow },
                      model: {
                        value: _vm.mitumori.client_company_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori, "client_company_name", $$v)
                        },
                        expression: "mitumori.client_company_name",
                      },
                    }),
                    _vm._v(" "),
                    !_vm.client_loading
                      ? _c(
                          "b-button",
                          {
                            staticClass: "icon_btn",
                            attrs: { variant: "info" },
                            on: { click: _vm.selectClientCompanyModalShow },
                          },
                          [
                            _c("b-icon", {
                              attrs: { icon: "search", "aria-hidden": "true" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.client_loading
                      ? _c(
                          "b-button",
                          {
                            staticClass: "icon_btn",
                            attrs: { variant: "info", disabled: "" },
                          },
                          [
                            _c("span", {
                              staticClass: "spinner-border spinner-border-sm",
                              attrs: { role: "status", "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("顧客担当者")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.mitumori.client_person_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.mitumori, "client_person_id", $$v)
                          },
                          expression: "mitumori.client_person_id",
                        },
                      },
                      [
                        _c("option"),
                        _vm._v(" "),
                        _vm._l(_vm.sel_client_person, function (option) {
                          return _c(
                            "option",
                            {
                              key: option.id,
                              domProps: { value: option.value },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(option.text) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("担当者")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.mitumori.user_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.mitumori, "user_id", $$v)
                          },
                          expression: "mitumori.user_id",
                        },
                      },
                      _vm._l(_vm.sel_person, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c(
                    "b-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.hide("modal-mitumori")
                        },
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "x" } }),
                      _vm._v("取消\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        "~click": function ($event) {
                          return _vm.createMitumori.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 保存\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }